import FlexSection from "@/partials/sections/Section/FlexSection";
import TeamMemberCardImage from "./TeamMemberCardImage/TeamMemberCardImage";
import TeamMemberCardDetails from "./TeamMemberCardDetails/TeamMemberCardDetails";

function TeamMemberCard({ member }) {
  return (
    <FlexSection extraClass={"flex-col items-center "}>
      <TeamMemberCardImage member={member} />
      <TeamMemberCardDetails member={member} />
    </FlexSection>
  );
}

export default TeamMemberCard;
